import { UserFlagsDisplayFlag } from '@xing-com/crate-common-graphql-types';

const trackCtaUrl = ({
  url,
  isPremium,
  displayFlag,
}: {
  url: string | null | undefined;
  isPremium: boolean;
  displayFlag: UserFlagsDisplayFlag;
}): string => {
  if (!url) return '';

  const newUrl = new URL(url);
  const isUpsellFlag = displayFlag === 'BASIC' || displayFlag === 'PREMIUM';

  if (!isPremium && isUpsellFlag) {
    newUrl.searchParams.append('sc_o', 'user_flag_upsell_click');
  } else {
    newUrl.searchParams.append('sc_o', 'user_flag_cta_click');
  }

  newUrl.searchParams.append(
    'sc_o_PropActionOrigin',
    `${displayFlag.toLowerCase()}_member`
  );

  return newUrl.toString();
};

export { trackCtaUrl };
